import { CanvasType } from '@meitu/saas-editor-core/es/version-types';
import { useStoreState } from '@/store';
import { checkImageEditor } from '@/utils/common';

const useDisplayAiExtend = () => {
    const canvasType = useStoreState((state) => state.templateModel.canvasType);
    const isImageEditor = checkImageEditor();

    return !isImageEditor && (canvasType === CanvasType.SINGLE || canvasType === CanvasType.NORMAL);
};

export default useDisplayAiExtend;
